import cx from "clsx"
import { ButtonLink } from "../../../components/ButtonLink"
import { SafeExitButton } from "../../../components/SafeExitButton"
import { HappyLayout } from "../../../components/HappyLayout"
import typography from "@rawa/ui/styles/typography.module.css"
import styles from "./FeedbackWelcomePage.module.scss"
import { pathHelpers } from "../../../paths"
import { useInvitation } from "../components/InvitationContext"

type Props = {
  invitationId: string
}

export function FeedbackWelcomePage({ invitationId }: Props) {
  const { firstName } = useInvitation()
  return (
    <HappyLayout
      heading={
        <h1 className={cx(typography.hero, styles.heading)}>
          Hello{firstName ? ` ${firstName}!` : "!"}
        </h1>
      }
    >
      <div className={styles.content}>
        <p className={typography.bodyLarge}>
          We would love to hear your feedback.
        </p>
        <ButtonLink href={pathHelpers.toFeedbackForm(invitationId)}>
          Provide Feedback
        </ButtonLink>
      </div>
      <SafeExitButton />
    </HappyLayout>
  )
}
